import React, { useEffect, useRef, useState } from 'react';

function Captcha({ onChange }) {
  const canvasRef = useRef(null);
  const [captcha, setCaptcha] = useState('');

  const generateCaptcha = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let code = '';
    for (let i = 0; i < 6; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(code);
    onChange(code);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    if (!captcha) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const fontSize = 18;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = `${fontSize}px Arial`;
    ctx.fillStyle = '#333';

    // Measure text width
    const textWidth = ctx.measureText(captcha).width;

    // Calculate center position
    const x = (canvas.width - textWidth) / 2;
    const y = (canvas.height + fontSize) / 2;

    ctx.fillText(captcha, x, y);
  }, [captcha]);

  return (
    <div className='d-flex'>
      <canvas ref={canvasRef} width={100} height={36} className="border rounded" />
      <button
        type="button"
        className="refresh-btn"
        onClick={generateCaptcha}
      >
        <i class="bi bi-arrow-clockwise"></i>
      </button>
    </div>
  );
}

export default Captcha;
